import React from "react";
import "./productunique2.css"
import Elasticseach from "../../assest/products/elasticsearch.jpg";
import Lansweeper from "../../assest/products/lansweeper.jpg";
import SnapLogic from "../../assest/products/snaplogic.jpg";
import Teramind from "../../assest/products/teramind.jpg";
 

const brands = [
  { name: "Elasticseach", description: "Log Security Big Data", img: Elasticseach },
  {
    name: "Lansweeper",
    description: "Asset and Monitoring",
    img: Lansweeper,
  },
  { name: "SnapLogic", description: "API Managment", img: SnapLogic },
  {
    name: "Teramind",
    description: "API Managment",
    img: Teramind,
  },
]
const Productunique2 = () => {
   

  return (
    <div className="hardware-container3">
       
      <p className="hardware-title">Unique Products</p>
      <div className="brand-grid">
        {brands.map((brand, index) => (
          <div className="brand-card" key={index}>
            <img src={brand.img} alt={brand.name} className="brand-image" />
            <div className="brand-overlay">
              <h3>{brand.name}</h3>
              {brand.description && <p>{brand.description}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Productunique2;
